
const Modal = props => {
    return (
        <>
            {
                props.isOpen && (
                    <div className={props.modalClass} onClick={props.toggle}>
                        {props.children}
                    </div>
                )
            }
        </>
    );
}

export default Modal;

export const ModalHeader = props => {
    return (
        <>
            <div className={props.modalHeaderClass}>
                {props.children}
            </div>
        </>
    )
}

export const ModalContent = props => {
    return (
        <>
            <div className={props.modalContent}>
                {props.children}
            </div>
        </>
    )
}
